export default function PropertyDetailsSection({
  location,
  propertyType,
}: {
  location: string;
  propertyType: string;
}) {
  return (
    <div className="flex justify-between md:justify-start items-center gap-2x">
      <p className="title !text-title_4">{location}</p>
      <span
        className="flex justify-center items-center py-0.5x w-auto 
      bg-gray text-gray__dark_2 rounded-[6px] text-caption_2 md:text-caption px-1.5x "
      >
        {propertyType}
      </span>
    </div>
  );
}
